import { useTranslation } from '@eti/providers';
import { useQuery } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FETCH_SEARCH_LOCATIONS_QUERY } from '../../widgets/search-form/containers/queries';
import Loading from '../../common/loading/components/Loading';
import { urlSearchParams } from './constants/queryParams';
import DestinationPage from './DestinationPage';

const { CARRIER, COUNTRY, DES, FROM, LOGO, RESTRICTED, TEXT, TO } = urlSearchParams;

const getDestinationPageLocation = (data, code) => {
  return data.searchLocations.filter((location) => location.iataCode === code.toUpperCase())[0];
};

const DestinationPageGraphqlContainer = () => {
  const { search } = useLocation();
  const { t } = useTranslation();

  const queryParams = new URLSearchParams(search);
  const carrierCode = queryParams.get(CARRIER);
  const countryCode = queryParams.get(COUNTRY);
  const originCode = queryParams.get(FROM) ?? '';
  const textCode = queryParams.get(TEXT);
  const destinationCode = queryParams.get(TO) ?? '';
  const destinationTextId = queryParams.get(DES);
  const logoParam = queryParams.get(LOGO) === 'true';
  const restrictedParam = queryParams.get(RESTRICTED) === 'true';

  const { data: originData, loading: originLoading } = useQuery(FETCH_SEARCH_LOCATIONS_QUERY, {
    variables: { searchTerm: originCode },
  });

  const { data: destinationData, loading: destinationLoading } = useQuery(
    FETCH_SEARCH_LOCATIONS_QUERY,
    { variables: { searchTerm: destinationCode } },
  );

  if (originLoading || destinationLoading) {
    return <Loading />;
  }

  const origin = getDestinationPageLocation(originData, originCode);
  const destination = getDestinationPageLocation(destinationData, destinationCode);
  return (
    <>
      <Helmet title={t('PageTitle.Destination', originCode, destinationCode)} />
      <DestinationPage
        carrierCode={carrierCode}
        countryCode={countryCode}
        destination={destination}
        destinationTextId={destinationTextId}
        hasLogo={logoParam}
        isRestricted={restrictedParam}
        origin={origin}
        textCode={textCode}
      />
    </>
  );
};

export default DestinationPageGraphqlContainer;
